<app-commitment-sidebar-title
  [showBackButton]="true"
  [title]="model().id ? 'Edit Prime Contract' : 'Add Prime Contract'"
  (goBack)="goBack()"
>
  <div (click)="createSOVsFromBudget()" class="cursor-pointer text-blue-700 flex gap-2 items-center">
    <span>Create From Budget</span>
    <span
      class="icon-download_budget text-size_icon_bigger"
      appTooltip="Copy the budget dollars respective to each budget line from the cashflow allocation."
    ></span>
  </div>
</app-commitment-sidebar-title>
<ng-scrollbar #scrollbar class="std-scrollbar flex-1" [appearance]="'compact'" orientation="vertical">
  <div class="flex flex-col flex-1">
    <form #spendEntriesPage="ngForm" role="form">
      @for (sov of model().sovs; track sov.id; let sovIndex = $index) {
        <app-commitment-entry-text
          (removeClicked)="removeSpendEntrySOV(sovIndex)"
          entryType="General"
          [index]="sovIndex"
          [text]="'Spend Entry'"
          [showRemoveIcon]="true"
        ></app-commitment-entry-text>
        <div class="flex flex-col my-2.5 mx-7">
          <div class="flex items-center gap-2">
            <app-floating-input
              [required]="true"
              class="w-full overflow-hidden"
              [ngModel]="sov.name"
              (ngModelChange)="onSOVNameChange($event, sovIndex)"
              [name]="'sov_' + sovIndex"
              [label]="'Schedule of value ' + (sovIndex + 1)"
              [placeholder]="'Schedule of value ' + (sovIndex + 1)"
            ></app-floating-input>

            <app-floating-input
              [disabled]="true"
              class="w-full"
              inputClass="bg-navy-100 opacity-100"
              [ngModel]="sovTotal()[sovIndex] | money: 'positiveComa'"
              [name]="'sov_total_' + sovIndex"
              label="Total Amount"
              placeholder="Total Amount"
            ></app-floating-input>
          </div>

          @for (scheduledItem of sov.scheduled_items; track scheduledItemIndex; let scheduledItemIndex = $index) {
            <div class="flex items-center gap-2">
              <app-dropdown
                [name]="'line_item_' + sovIndex + '_' + scheduledItemIndex"
                class="flex-1 min-w-0"
                label="Line Item"
                placeholder="Line Item"
                [options]="allLineItemsAsDropdown$ | async"
                [ngModel]="scheduledItem.item_id"
                (ngModelChange)="onLineItemChange($event, sovIndex, scheduledItemIndex)"
                [disabledOptionIds]="disabledLineItemIds()"
                [required]="true"
                searchPlaceholder="Search Line Items..."
                [searchBar]="true"
              >
                <ng-template #optionContent let-option>
                  @if (option) {
                    <div class="option">
                      <div class="flex flex-col">
                        <div class="capitalize text-size_m font-semibold">{{ option?.label }}</div>
                        <div class="capitalize text-size_m font-normal">
                          {{ option?.data?.division }} {{ option?.data?.cost_type }}
                        </div>
                      </div>
                      <div class="text-size_m">
                        {{ option?.data?.current_budget | money: 'shortSimpleSpace' }}
                      </div>
                    </div>
                  }
                </ng-template>
              </app-dropdown>

              <div class="flex-1 min-w-0 flex items-center gap-2">
                <app-floating-input
                  [required]="true"
                  class="w-full"
                  [ngModel]="scheduledItem.value"
                  (ngModelChange)="onLineItemValueChange($event, sovIndex, scheduledItemIndex)"
                  [name]="'value_' + sovIndex + '_' + scheduledItemIndex"
                  label="Dollar Amount"
                  placeholder="Dollar Amount"
                  type="money"
                ></app-floating-input>

                <app-add-remove-buttons
                  class="mt-4"
                  [disabledRemove]="sov.scheduled_items.length === 1"
                  [disabledAdd]="(allLineItemsAsDropdown$ | async).length <= sov.scheduled_items.length"
                  (removeItem)="removeScheduledItem(sovIndex, scheduledItemIndex)"
                  (addItem)="addScheduledItem(sovIndex, scheduledItemIndex)"
                >
                </app-add-remove-buttons>
              </div>
            </div>
          }
        </div>
      }
    </form>
  </div>

  <app-simple-button
    class="flex px-7 my-2.5"
    size="large"
    [wrapperClass]="{ 'w-full': true }"
    buttonStyle="color_secondary_border"
    (click)="addEmptySpendEntrySOV()"
    >Add Spend Entry</app-simple-button
  >
</ng-scrollbar>

<div class="mt-auto border-b border-b-solid border-navy-300"></div>

<div class="my-6 mx-7 flex justify-between items-center gap-4">
  <div class="text-navy-900 text-sm font-bold">Total Contract</div>
  <div class="text-navy-900 text-sm font-bold">
    {{ totals() | money: 'comaSign' }}
  </div>
  <app-simple-button (click)="goToNextPage()"> Next </app-simple-button>
</div>
